import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { HeroBannerFeaturedCardList } from './HeroBannerFeaturedCardList';
import { JoinContainer } from './JoinContainer';

type Props = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
};

export const HeroBanner = ({ className, shouldUseHomePageRedesign = false }: Props) => {
    return (
        <div
            className={cn('flex flex-col', className)}
            data-testid="treasureHuntingContainer"
        >
            <div
                className={cn(
                    'mx-auto my-0 flex h-full max-h-[238px] smMax:max-h-none smMax:flex-col',
                    shouldUseHomePageRedesign
                        ? 'w-full max-w-full items-start gap-2xl smMax:gap-md'
                        : 'w-[calc(100%-40px)] max-w-[1200px]'
                )}
            >
                <JoinContainer shouldUseHomePageRedesign={shouldUseHomePageRedesign} />
                <HeroBannerFeaturedCardList shouldUseHomePageRedesign={shouldUseHomePageRedesign} />
            </div>
        </div>
    );
};
